import ko from '@tko/build.knockout';
import $ from 'jquery';
import moment from 'moment-timezone';
import _ from 'lodash';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';
import FilterFormatter from './filter-formatter';
import meetingsCommon from '../helpers/meetings-common';



    var dateFormat = 'MM/DD/YYYY HH:mm:ss';
    var meetingPriorityMap = meetingsCommon.getMeetingPriorityMap();

    function ScheduledMeetinsGridFormatter(params, observableOptions) {
        this.observableOptions = observableOptions;

        this.formatterCommon = FormatterCommon;
        this.gridFormatterCommon = new GridFormatterCommon();
        this.filterFormatter = new FilterFormatter();

        this.observableFormattedData = ko.observable();

        this.sourceList = ko.observableArray();
        this.usersList = ko.observableArray();

        this.subscriptions = [];
    }

    function ComposeData(sourceList, options, formatters, metadata, usersList, callbacks) {
        const colWidths = formatters.gridFormatterCommon.getColWidths(gridCols);
        var hiddenCols = _.get(options, 'searchGrid.hiddenCols', []);

        var gridCols = _.filter(metadata.searchGrid, function (col) {
            return !_.includes(hiddenCols, col.key);
        });
        const headers = _.map(gridCols, 'header');

        if (_.isEmpty(sourceList)) {
            return formatters.gridFormatterCommon.composeEmpty(headers, undefined, colWidths);
        }
        var toggleInnerCell = metadata.innerTable.toggleInnerCell;

        var searchfilter = _.map(_.get(options, 'filter.search', []), formatters.filterFormatter.typeaheadToGridFilter);
        var priorityFilter = _.get(options, 'filter.priority', null);
        var assigneesFilter = _.get(options, 'filter.assignees', null);

        var selectedDateRange = _.get(options, 'filter.dateRange', getDateRange());
        if (!isValidDateRange(selectedDateRange)) {
            selectedDateRange = getDateRange();
        }


        var rowProperties = _.map(gridCols, 'key');

        var filteredList = [];

        _.each(sourceList, function (item) {
            var formattedItem = {};

            formattedItem.id = _.get(item, 'scheduleKey');
            formattedItem.conferenceID = _.get(item, 'conf.id');

            setMeetingNameAndPriority(formattedItem, item.conf);

            formattedItem.startTime = formatters.gridFormatterCommon.getTimeString(_.get(item, 'conf.startTime'));
            formattedItem.endTime = formatters.gridFormatterCommon.getTimeString(_.get(item, 'conf.endTime'));

            formattedItem.duration = _.has(item, 'conf.duration') ? moment.duration(_.toNumber(item.conf.duration), 's').minutes() : null;
            // used only for search
            formattedItem._participants = _.map(_.get(item, 'conf.participants'), 'name').join(',');

            formattedItem.notes = _.get(item, 'assignment.notes');
            formattedItem.assignedUser = _.get(item, 'assignment.user.name');

            formattedItem.edit = '<i class="fa fa-edit" title="Edit"></i>';

            formattedItem._actionCallback = function (index) {
                if (index === rowProperties.indexOf('edit')) {
                    showEditModal(item, usersList, callbacks.update);
                }
            };

            formattedItem._nameText = formattedItem.name;

            if (_.isArray(_.get(item, 'conf.participants'))) { // check if has participants array
                formattedItem = composeChildTable(formattedItem, item.conf, metadata.innerTable, formatters.gridFormatterCommon);
            }

            // Filter should be boolean or a function what returns bool value.
            var filters = [
                isInDateRange.bind(null, formattedItem, selectedDateRange, dateFormat),
                isInArray.bind(null, formattedItem, priorityFilter, 'priority'),
                isInArray.bind(null, item, assigneesFilter, 'assignment.user.id'),
                function() {
                    return !_.isEmpty(searchfilter) ? formatters.filterFormatter.matchAll(formattedItem, searchfilter) : true;
                }
            ];

            // iterate over and invoking filter functions. Stop and reject item if at least one filter fails.
            var rejectItem = _.some(filters, function(filter) {
                if (_.isFunction(filter)) {
                    return !filter();
                }
                return !filter;
            });

            if (!rejectItem) {
                filteredList.push(formattedItem);
            }
        });

        var sortableCols =  _.map(_.filter(gridCols, 'sortable'), function(col) {
            return col.sortKey || col.key;
        });

        var sortedList = formatters.gridFormatterCommon.sortList(filteredList, sortableCols, options, metadata.numericKeys);
        var rows = formatters.gridFormatterCommon.pageList(sortedList, options);

        if (_.isEmpty(rows)) {
            rows = formatters.gridFormatterCommon.composeEmpty(headers, undefined, colWidths).rows;
        }

        return {
            maxCount: filteredList.length,
            filters: metadata.typeaheadConditions,
            timeRange: selectedDateRange,
            rows: rows,
            rowProperties: rowProperties,
            widths: colWidths,
            headers: headers,
            actionIndexes: [8],
            innerRowDisplayIndex: rowProperties.indexOf(toggleInnerCell),
            innerWidths: metadata.innerTable.widths,
            metadata: metadata,
            usersList: usersList
        };
    }

    function composeChildTable(parentRow, dataset, metadata, gridFormatterCommon) {
        var innerData = dataset.participants;

        parentRow.innerTable = {
            headers: ko.observableArray(metadata.innerheaders),
            rows: ko.observable(_.get(parentRow, 'participants')),
            currentPage: ko.observable(1),
            totalPages: ko.observable((Math.ceil(innerData.length / metadata.pageSize))),
            sortAsc: ko.observable(true),
            sortIndex: ko.observable(),
            displayCols: ko.observable(metadata.rowProperties),
            recordCount: innerData.length
        };

        parentRow._showInnerPager = ko.observable((ko.unwrap(parentRow.innerTable.totalPages) > 1));


        parentRow._loadInnerRows = function (page) {
            parentRow.innerTable.currentPage(page || 1);

            var sortedList = gridFormatterCommon.sortList(innerData, metadata.sortableCols, ko.toJS(parentRow.innerTable));
            var pagedRows = gridFormatterCommon.pageList(sortedList, { pageSize: metadata.pageSize, pageNum: ko.unwrap(parentRow.innerTable.currentPage) });

            parentRow.innerTable.rows((!_.isEmpty(pagedRows) ? pagedRows : []));

            // unclear why this needs to return a promise that resolves with no data
            return Promise.resolve();
        };

        return parentRow;
    }

    function showEditModal(meeting, users, updateCallback) {
        var $editMeetingModal = $("#rt-scheduled-meeting-edit-modal");
        var editMeetingVM = ko.dataFor($editMeetingModal[0]);

        editMeetingVM.setData(meeting, users, updateCallback);
        $editMeetingModal.modal('show');
    }

    function setMeetingNameAndPriority(item, source) {
        _.each(_.keys(meetingPriorityMap), function (priorityKey) {
            if (_.startsWith(source.name, priorityKey)) {
                item.name = _.replace(source.name, priorityKey, '');
                item.priority = meetingPriorityMap[priorityKey];
            }
        });

        if (!item.name) {
            item.name = source.name;
            item.priority = null;
        }
    }

    function isValidDateRange(dateRange) {
        return moment(dateRange.startDate).isValid() && moment(dateRange.endDate).isValid();
    }

    function getDateRange() {
        return {
            startDate: moment(),
            endDate: moment().add(30, 'days')
        };
    }

    function isInDateRange(item, dateRange, dateFormat) {
        var startMatch = moment(item.startTime, dateFormat).isBetween(dateRange.startDate, dateRange.endDate);
        var endMatch = moment(item.endTime, dateFormat).isSameOrBefore(dateRange.endDate);

        return startMatch && endMatch;
    }

    function isInArray(item, filter, propPath) {
        return _.isEmpty(filter) || _.includes(filter, _.get(item, propPath));
    }

    ScheduledMeetinsGridFormatter.prototype.RefreshData = function () {
        var formattedData = ComposeData(
            this.sourceList(),
            this.observableOptions(), {
                filterFormatter: this.filterFormatter,
                gridFormatterCommon: this.gridFormatterCommon,
                formatterCommon: this.formatterCommon
            },
            this.dataRepository.getScheduledMeetingsMetadata(),
            this.usersList(),
            {
                update: this.updateMeeting.bind(this)
            }
        );
        this.observableFormattedData(formattedData);
    };

    ScheduledMeetinsGridFormatter.prototype.updateMeeting = function(scheduleKey, assignment) {
        var meetings = this.sourceList();
        var updatedMeetingIndex =_.findIndex(meetings, ['scheduleKey', scheduleKey]);

        if (updatedMeetingIndex < 0) {
            return false;
        }
        meetings[updatedMeetingIndex].assignment = assignment;
        this.sourceList(meetings);
    };

    ScheduledMeetinsGridFormatter.prototype.initialize = function (dataRepository) {
        this.dataRepository = dataRepository;

        if (_.isEmpty(this.sourceList())) {
            this.sourceList(this.dataRepository.tmsScheduleData());
        }

        if (_.isEmpty(this.usersList())) {
            this.usersList(this.dataRepository.usersList());
        }

        this.subscriptions.push(dataRepository.tmsScheduleData.subscribe(function(sourceList) {
            this.sourceList(sourceList);
        }.bind(this)));

        this.subscriptions.push(dataRepository.usersList.subscribe(function(usersList) {
            this.usersList(usersList);
        }.bind(this)));

        this.subscriptions.push(this.observableOptions.subscribe(this.RefreshData.bind(this)));
        this.subscriptions.push(this.usersList.subscribe(this.RefreshData.bind(this)));
        this.subscriptions.push(this.sourceList.subscribe(this.RefreshData.bind(this)));

        this.RefreshData();
    };

    ScheduledMeetinsGridFormatter.prototype.getObservableData = function () {
        return this.observableFormattedData;
    };

    ScheduledMeetinsGridFormatter.prototype.dispose = function () {
        this.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default ScheduledMeetinsGridFormatter;
